import React, { useState } from "react";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Industries from "./pages/Industries";
import Courses from "./pages/Courses";
import Modules from "./pages/Modules";
import Lessons from "./pages/Lessons";
import AddLesson from "./pages/AddLesson";
import EditLesson from "./pages/EditLesson";
import Students from "./pages/Students";
import AddStudent from "./pages/AddStudent";
import EditStudent from "./pages/EditStudent";
import Access from "./pages/Access";

import AdminsList from "./pages/AdminsList";
import CreateAdmin from "./pages/CreateAdmin";
import EditAdmin from "./pages/EditAdmin";
import TrainersList from "./pages/TrainersList";
import TrainerForm from "./pages/TrainerForm";

import Sidebar from "./components/Sidebar";
import Navbar from "./components/Navbar";

function App() {

  const [loggedIn, setLoggedIn] = useState(
    localStorage.getItem("token") ? true : false
  );

  const [page, setPage] = useState({ page: "dashboard" });

  if (!loggedIn) {
    return <Login setLoggedIn={setLoggedIn} />;
  }

  const renderPage = () => {

    switch (page.page) {

      case "dashboard":
        return <Dashboard />;

      case "industries":
        return <Industries />;

      case "courses":
        return <Courses />;

      case "modules":
        return <Modules />;

      case "lessons":
        return <Lessons setPage={setPage} />;

      case "add-lesson":
        return <AddLesson setPage={setPage} />;

      case "edit-lesson":
        return (
          <EditLesson
            lessonId={page.lessonId}
            setPage={setPage}
          />
        );

      case "students":
        return <Students setPage={setPage} />;

      case "add-student":
        return <AddStudent setPage={setPage} />;

      case "edit-student":
        return (
          <EditStudent
            studentId={page.studentId}
            setPage={setPage}
          />
        );

      /* ================= ADMINS ================= */

      case "admins":
        return <AdminsList setPage={setPage} />;

      case "add-admin":
        return <CreateAdmin setPage={setPage} />;

      case "edit-admin":
        console.log("PAGE STATE:", page);
        return (
          <EditAdmin
            adminId={page.adminId}
            setPage={setPage}
          />
        );



      case "trainers":
        return <TrainersList setPage={setPage} />;

      case "add-trainer":
        return <TrainerForm setPage={setPage} />;

      case "edit-trainer":
        return <TrainerForm trainerId={page.trainerId} setPage={setPage} />;

      case "access":
        return <Access />;

      default:
        return <Dashboard />;
    }

  };

  return (

    <div style={{ display: "flex" }}>

      <Sidebar setPage={setPage} />

      <div style={{ flex: 1 }}>

        <Navbar />

        <div style={{ padding: "20px" }}>
          {renderPage()}
        </div>

      </div>

    </div>

  );

}

export default App;